module.exports = __webpack_public_path__ + "img/13.a0238106.png";